import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backroundColor: '#ffffff',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const DeleteAllTripsAlertDialog = withStyles((theme) => ({
    paper: {
      backgroundColor: '#ffffff'
    },
}))(Dialog);

const DeleteAllTripsAlertCloseButton = withStyles((theme) => ({
    root: {
        color: theme.palette.primary.main
    },
}))(Button);


const DeleteAllTripsAlert = ({deleteAlertOpen, setDeleteTripAlertClose, deleteAllTrips}) => {
  return (
    <div>
      <DeleteAllTripsAlertDialog onClose={setDeleteTripAlertClose} aria-labelledby="customized-dialog-title" open={deleteAlertOpen}>
        <DialogTitle id="customized-dialog-title" onClose={setDeleteTripAlertClose}>
          Delete All Trips
        </DialogTitle>
        <DialogContent dividers>
          <Typography>
            Are you sure you want to delete all trips?
          </Typography>
        </DialogContent>
        <DialogActions>
          <DeleteAllTripsAlertCloseButton autoFocus onClick={setDeleteTripAlertClose}>
            Cancel
          </DeleteAllTripsAlertCloseButton>
          <DeleteAllTripsAlertCloseButton autoFocus onClick={deleteAllTrips} style={{color: '#B52626'}}>
            Delete
          </DeleteAllTripsAlertCloseButton>
        </DialogActions>
      </DeleteAllTripsAlertDialog>
    </div>
  );
}

export default DeleteAllTripsAlert;